module.exports = __webpack_public_path__ + "static/media/skip_avatar.11b069a4.png";